/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAdd } from '../../factoriesNumber.js';
export var addDependencies = {
  typedDependencies,
  createAdd
};